import { IFaqGroup } from 'src/models/faq.model';
import { EntityActions } from '../entity.actions';

export const fromFaqActions = EntityActions.create<IFaqGroup>('[Faq]');
